import { makeObservable, action, observable } from "mobx";
class BrandStore {
  brand = "TELIA";
  constructor() {
    makeObservable(this, {
      brand: observable,
      setBrand: action
    });
  }
  setBrand(brand) {
    this.brand = brand.toUpperCase();
  }
}
export {
  BrandStore as default
};
